import { render, staticRenderFns } from "./EstimatedDeliveryPrice.vue?vue&type=template&id=31c8ad30&"
import script from "./EstimatedDeliveryPrice.vue?vue&type=script&lang=js&"
export * from "./EstimatedDeliveryPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports